import styles from "./collapsible.module.css"
import {useEffect} from "react";
import Link from "next/link";
import {useRouter} from "next/router";

export default function Collapsible({title, content, theme, children, group, titleLink, style}){
    const router = useRouter();
    return (
      <>
          <hr size="1" width="100%"/>
          <div style={style} className={theme=='dark' ? `${styles.title} ${styles.dark}` : `${styles.title}`} onClick={() => titleLink == undefined ? toggleCollapse(title, group) : null}><span onClick={()=> titleLink != undefined ? router.push(titleLink) : null}>{title}</span><span id={`indicator-${title}`} className={theme=='dark' ? `${styles.indicator} ${styles.dark}  ${group}` : `${styles.indicator}  ${group}`} onClick={() => titleLink && toggleCollapse(title, group)} /></div>
          <div id={`collapsible-${title}`} className={`${styles.content} ${group}`}>
              { content && <p dangerouslySetInnerHTML={{__html:content}}></p>}
              {children && children}
          </div>
      </>
    );
}

function toggleCollapse(id, group) {
    let content = document.getElementById(`collapsible-${id}`);
    let indicator = document.getElementById(`indicator-${id}`);

    
    if(content.classList.contains(styles.showContent))
    {
        content.classList.remove(styles.showContent);
        indicator.classList.remove(styles.open);
    }else{
        if(group){
            let others = document.getElementsByClassName(group);
            
            Array.prototype.forEach.call(others, function(x){x.classList.remove(styles.showContent); x.classList.remove(styles.open)});
        }
        content.classList.add(styles.showContent);
        indicator.classList.add(styles.open);
    }
}